/**
 * Shared AI input row widget.
 * Used by ToolbarManager, ImagePanel, GeneralAIPanel, FormulaManager.
 */

import { CONFIG } from './config'

export function createAIInputRow(label?: string, placeholder?: string): HTMLDivElement {
  const html = [
    '<div class="musk-ai-row">',
    `  <span class="musk-ai-label">${label || 'AI'}</span>`,
    `  <input type="text" class="musk-ai-input" placeholder="${placeholder || '描述你的修改需求...'}">`,
    '  <button class="musk-ai-send" disabled>',
    '    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor"><path d="M15.85 7.65l-14-7a.5.5 0 00-.7.6L2.85 7.5H9v1H2.85l-1.7 6.25a.5.5 0 00.7.6l14-7a.5.5 0 000-.7z"/></svg>',
    '  </button>',
    '</div>',
    '<div class="musk-ai-preview"></div>',
    '<div class="musk-ai-preview-actions">',
    '  <button class="musk-ai-discard">放弃</button>',
    '  <button class="musk-ai-regenerate"><svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><path d="M13.65 2.35A8 8 0 1 0 16 8h-2a6 6 0 1 1-1.76-4.24L10 6h6V0l-2.35 2.35z"/></svg>重新生成</button>',
    '  <button class="musk-ai-apply">应用</button>',
    '</div>',
  ].join('\n')
  const wrap = document.createElement('div')
  wrap.className = 'musk-ai-widget'
  wrap.innerHTML = html
  return wrap
}

/**
 * Find the nearest "general" element (non-text-editable, non-formula container)
 * that has a data-musk-element-id and is in the GENERAL_HOVER_TAGS set.
 */
export function findGeneralElement(target: Element): Element | null {
  let el: Element | null = target
  while (el && el !== document.body && el !== document.documentElement) {
    if (
      el.hasAttribute?.('data-musk-element-id')
      && el.getAttribute(CONFIG.EDITABLE_ATTR) !== 'true'
      && el.tagName !== 'MJX-CONTAINER'
      && !el.closest('mjx-container')
      && CONFIG.GENERAL_HOVER_TAGS.has(el.tagName)
    ) {
      return el
    }
    el = el.parentElement
  }
  return null
}
